import { DefaultCartService } from '@/services/cart/DefaultCartService';
import { CartServiceBase } from '@/services/cart/CartServiceBase';
import { FairCartService } from '@/services/cart/FairCartService';
import ProductService from '@/services/product/ProductService';
import DefaultProductService from '@/services/product/DefaultProductService';
import FairProductService from '@/services/product/FairProductService';
import ProductCompletionService from '@/services/product/completion/ProductCompletionService';
import DefaultProductCompletionService from '@/services/product/completion/DefaultProductCompletionService';
import FairProductCompletionService from '@/services/product/completion/FairProductCompletionService';

export abstract class DependencyService {
  private static cartService: CartServiceBase
    = DependencyService.defaultCartService();
  private static productService: ProductService
    = DependencyService.defaultProductService();
  private static productCompletionService: ProductCompletionService
    = DependencyService.defaultProductCompletionService();

  public static defaultCartService(): DefaultCartService {
    return DefaultCartService.singleton();
  }

  public static defaultProductService(): DefaultProductService {
    return DefaultProductService.singleton();
  }

  public static defaultProductCompletionService(): DefaultProductCompletionService {
    return DefaultProductCompletionService.singleton();
  }

  public static getCartService(): CartServiceBase {
    return this.cartService;
  }

  public static getProductService(): ProductService {
    return this.productService;
  }

  public static getProductCompletionService(): ProductCompletionService {
    return this.productCompletionService;
  }

  public static configure(el?: HTMLElement) {
    if (!el) {
      this.applyDefaultConfig();
      return;
    }

    const config = DependencyConfig.fromElement(el);

    switch (config.webshopType) {
      case WebshopType.FAIR:
        this.applyFairConfig(config);
        break;
      default:
        this.applyDefaultConfig();
    }

    this.cartService.fetchCart();
  }

  private static applyDefaultConfig() {
    this.cartService = DependencyService.defaultCartService();
    this.productService = DependencyService.defaultProductService();
  }

  private static applyFairConfig(config: DependencyConfig) {
    this.cartService = new FairCartService(config.fairCode);
    this.productService = new FairProductService(config.fairCode);
    this.productCompletionService = new FairProductCompletionService(config.fairCode);
  }

}

class DependencyConfig {
  public webshopType: WebshopType;
  public fairCode: string;

  private constructor(webshopType: WebshopType, fairCode: string) {
    this.webshopType = webshopType;
    this.fairCode = fairCode;
  }

  public static fromElement(el: HTMLElement): DependencyConfig {
    const config = el.dataset as ConfigFields;

    const fairCode = config.fairCode || '';
    const type = config.typeCode as WebshopType || WebshopType.DEFAULT;

    return new DependencyConfig(type, fairCode);
  }

}

enum WebshopType {
  DEFAULT = 'default', FAIR = 'fair'
}

class ConfigFields {
  public fairCode?: string;
  public typeCode?: string;
}
